import React from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

const CommonButtonActionButton = ({ 
  label, 
  startIcon, 
  variant, 
  onClick, 
  disabled = false, 
  component = "button", 
  inputProps = {}, 
  children ,
  className,
  sx={},
  buttonVarient="contained",
  ...props
}) => {
  // Default styling for variants
  const buttonStyles = {
    upload: {
      border: '1px solid var(--Primary-Color, #55636d)',
      color: 'var(--Primary-Color, #55636d)',
      backgroundColor: 'transparent',
      opacity: 0.7,
      '&:hover': {
        opacity: 1,
      },
    },
    download: {
      backgroundColor: 'var(--Secondary-Color, #fdb908)',
      color: 'var(--primary-contrastText, #fff)',
      '&:hover': {
        backgroundColor: 'var(--Secondary-Color, #fca506)',
      },
    },
    default: {
      backgroundColor: 'rgba(247, 170, 71, 1)',
      color: '#fff',
      '&:hover': {
        backgroundColor: 'rgba(247, 170, 71, 1)',}
    },
    secondary: {
      backgroundColor: 'transparent',
    
      border: '1px solid var(-3rd-Color, #0B2256)',
      color: 'var(-3rd-Color, #070A83)',
      
     
    },
  };

  return (
    <Button
      component={component}
      variant={buttonVarient}
      startIcon={startIcon}
      en
      disabled={disabled}
      sx={{
        borderRadius: '10px',
        padding: '6px 16px',
        ...buttonStyles[variant || 'default'], // Default style fallback
        ...sx, // Merging custom sx
      }}
      className={className}
      onClick={onClick}
      {...props}
    >
      {label}
      {children}
    </Button>
  );
};

CommonButtonActionButton.propTypes = {
  label: PropTypes.string,
  startIcon: PropTypes.node,
  variant: PropTypes.oneOf(['upload', 'download', 'default']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  component: PropTypes.string,
  inputProps: PropTypes.object,
  children: PropTypes.node,
};

export default CommonButtonActionButton;
